import WelcomeCarousel from '@frontend/components/WelcomeCarousel';
import slide2 from '@frontend/public/assets/images/group-18.png';
import slide3 from '@frontend/public/assets/images/group-19.png';
import slide1 from '@frontend/public/assets/images/new_logo.png';
import { Button } from '@radix-ui/themes';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { motion } from 'framer-motion';
import { useCallback, useState } from 'react';
import { useConnect } from 'wagmi';
import { coinbaseWallet } from 'wagmi/connectors';

const welcomeSlides = [
  {
    title: 'Welcome to Yodl Pay',
    subtitle: 'To get started, create a new wallet or use an existing one',
    img: slide1,
  },
  {
    title: 'Pay at millions of merchants. Soon™',
    subtitle:
      'Pay directly from your wallet at millions of merchants. No CC needed.',
    img: slide2,
  },
  {
    title: 'Your wallet, your way',
    subtitle:
      'Create a smart wallet with passkeys  or use your existing wallet.',
    img: slide3,
  },
];

export default function WalletConnect() {
  const { openConnectModal } = useConnectModal();
  const { connectAsync } = useConnect();
  const [isConnecting, setIsConnecting] = useState(false);

  const handleCreateSmartWallet = useCallback(async () => {
    setIsConnecting(true);
    try {
      await connectAsync({
        connector: coinbaseWallet({
          appName: 'yodl',
          preference: 'smartWalletOnly',
        }),
      });
    } catch (error) {
      console.error('Coinbase Smart Wallet connection failed:', error);
    } finally {
      setIsConnecting(false);
    }
  }, [connectAsync]);

  return (
    <motion.div
      className="fixed inset-0 w-full h-full flex flex-col items-center justify-center overflow-y-auto box-border px-4 py-6 z-[9999] bg-white light"
      id="welcome-page-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div
        id="welcome-page-background"
        className="fixed"
        style={{
          width: '444px',
          height: '551px',
          background:
            'linear-gradient(137.25deg, rgba(140, 88, 250, 0.4) -1.37%, rgba(70, 18, 180, 0.4) 82.84%)',
          filter: 'blur(210px)',
          zIndex: -1,
        }}
      />

      <motion.div
        className="relative z-10 w-full max-w-sm mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <WelcomeCarousel slides={welcomeSlides} bottomSpacing="mb-6" />

        <div className="flex flex-col gap-6 mt-8">
          <div className="shadow-[0px_3px_10px_0px_#3E0AAC66] rounded-full">
            <Button
              size="3"
              className="!w-full"
              radius="full"
              onClick={handleCreateSmartWallet}
              loading={isConnecting}
              disabled={isConnecting}
            >
              Create smart wallet
            </Button>
          </div>
          <button
            className="w-full text-center text-[#4612B4] text-base font-medium py-3 cursor-pointer"
            onClick={() => openConnectModal?.()}
          >
            I already have a wallet
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
}
